import {
  MobilePageHeader,
  MobileModalContent,
  Button,
  MobilePageDescription,
} from "../../../components";
import { Container, Row, Col } from "react-grid-system";
import React from "react";
import { setModalContent, setModalVisible } from "../../../store/modal/actions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Error({
  title,
  desc,
  backUrl = "/",
  backBtnText = "На главную",
  showSupportLink = false,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const goToMain = () => {
    dispatch(setModalVisible(false));
    dispatch(setModalContent(null));
    history.push(backUrl);
  };

  const supportLink = (
    <a
      href={"https://t.me/sixtamp"}
      target={"_blank"}
      rel={"noopener noreferrer"}
      style={{
        color: "#209cee",
        textDecoration: "underline",
        cursor: "pointer",
      }}
    >
      {t("views.popovers.support_link")}
    </a>
  );

  return (
    <Container>
      <MobileModalContent height={"100%"}>
        <Row>
          <Col xs={12}>
            <MobilePageHeader>{title}</MobilePageHeader>
          </Col>
        </Row>
        {desc && (
          <Row>
            <Col xs={12}>
              <MobilePageDescription>
                {desc}
                {showSupportLink && (
                  <>
                    {" "}
                    {t("views.popovers.support_hint")}
                    {supportLink}
                  </>
                )}
              </MobilePageDescription>
            </Col>
          </Row>
        )}
        <Row>
          <Col xs={12}>
            <Button role={"secondary"} display={"block"} onClick={goToMain}>
              {backBtnText}
            </Button>
          </Col>
        </Row>
      </MobileModalContent>
    </Container>
  );
}
